import {
  constants,
  type FilterChipStyleOverrides,
  type AngelouCSS,
} from "@newsela/angelou";

import { rootChipCss } from "@/search/NewSearchPageMVP/FilterPanel/FilterPanel.styles";

const white = constants.colors.ui.white[50];
const darkestNeutral = constants.colors.ui.neutral[700];
const hoverGrey = "rgba(234, 235, 236, 1)";

export const getContentTypeChipCss = (
  isActive: boolean,
  isSelectAllChip?: boolean,
): FilterChipStyleOverrides<AngelouCSS> => ({
  root: {
    fontWeight: "bold",
    backgroundColor: isActive ? darkestNeutral : white,
    color: isActive ? white : darkestNeutral,

    ...rootChipCss,

    "&:hover": {
      backgroundColor: isActive ? darkestNeutral : hoverGrey,
    },
  },

  text: {
    paddingRight: isSelectAllChip ? "" : "8px",
  },

  Icon: {
    root: {
      "*": {
        strokeWidth: "2px",
        ...(isActive && { stroke: white }),
      },
    },
  },
});
